import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'Core/services';
import { isNil } from 'lodash';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthenticationService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken: string | null = localStorage.getItem('accessToken');
    let authReq: HttpRequest<unknown> = req;

    if (!isNil(accessToken)) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` },
      });
    }

    return next.handle(authReq).pipe(
      catchError(error => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          !req.url.includes('/auth/refresh-token') &&
          authReq.headers.has('Authorization')
        ) {
          return this.authService.updateRefreshToken().pipe(
            switchMap((tokens: { accessToken: string }) => {
              const clonedReq: HttpRequest<unknown> = req.clone({
                setHeaders: { Authorization: `Bearer ${tokens.accessToken}` },
              });
              return next.handle(clonedReq);
            }),
            catchError(() => {
              return this.authService.logout().pipe(switchMap(() => EMPTY));
            })
          );
        }

        return throwError(() => error);
      })
    );
  }
}
